<template>
    <div class="d-flex flex-column justify-center">
        <v-progress-circular indeterminate color="primary" :size="50"/>
        <span class="mt-5">Loading...</span>
    </div>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({

})
</script>
